module.exports = __webpack_public_path__ + "static/media/resultats_J1.3bfc9954.pdf";